import { useAppSelector } from 'appState/store'

import { cppuChangePassword } from 'features/userManagement/userApi'
import { useState } from 'react'
import { Button } from '@outbound-ai/ursa'
import styled from 'styled-components'
import { ColorsEnum, ColorsToneEnum } from 'types/cssTypes'
import { notificator } from 'utils/notificator/notificator'
import { useUserProfile } from '../settingsHooks'

export const SettingsProfile = () => {
  // global state
  const { user } = useAppSelector((state) => state.auth)

  // api
  const { data: profile } = useUserProfile(user?.id)
  const [isChangingPassword, setIsChangingPassword] = useState(false)

  const handelChangePassword = () => {
    if (!profile || isChangingPassword) return
    setIsChangingPassword(true)
    cppuChangePassword(profile.username)
      .then(() => {
        notificator.notify({
          type: 'success',
          heading: `Password Reset link sent to ${profile.email}`,
        })
      })
      .catch((error) => {
        notificator.notify({
          type: 'error',
          heading: error.message || 'Something went wrong',
        })
      })
      .finally(() => {
        setIsChangingPassword(false)
      })
  }

  return (
    <>
      <Div>
        <section className="body">
          {profile && (
            <>
              <div className="details-row">
                <div className="details-container">
                  <div className="details-label">Display Name</div>
                  <div className="details-value">
                    {profile.givenName} {profile.familyName}
                  </div>
                </div>
                {/* Commented until the backend provides the functionality */}
                {/* <Button variant="outlined" size="largeInline">
                  Edit
                </Button> */}
              </div>

              <div className="details-row">
                <div className="details-container">
                  <div className="details-label">Mobile Phone Number</div>
                  <div className="details-value">{profile.cognitoPhoneNumber}</div>
                </div>
                {/* Commented until the backend provides the functionality */}
                {/* <Button variant="outlined" size="largeInline">
                  Edit
                </Button> */}
              </div>

              <div className="details-row">
                <div className="details-container">
                  <div className="details-label">Password </div>
                </div>
                <Button
                  variant="primary-outline"
                  size="large"
                  width="100%"
                  radius="rounded"
                  onClick={() => handelChangePassword()}
                >
                  {isChangingPassword ? 'Processing...' : 'Change Password'}
                </Button>
              </div>

              {/* Commented until the backend provides the functionality, currently the backend does not populate the activatedMfaOptions array despite an user having SMS Mfa Enabled */}
              {/* {!!profile?.activatedMfaOptions.length && (
                <div className="details-row">
                  <div className="details-container">
                    <div className="details-label">
                      Two-factor Authentication{' '}
                      <LabelStyled bgColor={ColorsEnum.primary} text="Required by your organization" />
                    </div>
                    <div className="details-value">{profile.email}</div>
                  </div>

                  <Button variant="outlined" size="largeInline">
                  Manage
                </Button>
                </div>
              )} */}
            </>
          )}
        </section>
      </Div>
    </>
  )
}

//* Please search for `SMS Mfa` in this file to understand why this is commented
// const LabelStyled = styled(Label)`
//   background-color: ${({ theme }) => theme.colors.primary.lightest};
//   color: ${({ theme }) => theme.colors.primary.darker};

//   font-weight: ${({ theme }) => theme.fontWeight.normal};
//   font-size: ${({ theme }) => theme.util.pixelToRem(10)};
//   padding: 0.25em 0.875em;
//   border-radius: ${({ theme }) => theme.borderRadius.normal};
// `

const Div = styled.div`
  .body {
    position: relative;

    .details-row {
      display: flex;
      justify-content: space-between;
      padding-block: 1.5rem;
      border-top: ${({ theme }) => theme.borders.s.solid(ColorsEnum.grey, ColorsToneEnum.light)};
      .details-container {
        color: ${({ theme }) => theme.colors.grey.darker};
        .details-label {
          font-size: ${({ theme }) => theme.util.pixelToRem(18)};
          font-weight: ${({ theme }) => theme.fontWeight.bold};
        }
        .details-value {
          font-size: 1rem;
          font-weight: ${({ theme }) => theme.fontWeight.normal};
        }
      }
      button {
        font-size: ${({ theme }) => theme.util.pixelToRem(13)};
        width: ${({ theme }) => theme.util.pixelToRem(169)};
        height: 2rem;
        font-weight: ${({ theme }) => theme.fontWeight.medium};
        padding-inline: 0rem;
        align-self: center;
      }
    }
  }
`
